import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Field, FieldProps, useField } from 'formik';
import classNames from 'classnames';
import ErrorMessage from 'hellospa/components/error-message';
import TextArea from 'hellospa/foundation/control/textarea';

import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

import messages from './intl';
import styles from './index.scss';


const DocumentSection = (() => {
  const intl = useIntl();
  const allowDocumentMessage = useSelector(selectors.allowDocumentMessage);
  const { lockDocumentMessage } = useSelector(selectors.getFlags);

  const [, documentMessageMeta] = useField({
    type: 'text',
    id: 'document.message',
    name: 'document.message',
  });


  return (
    <div className={styles.documentFields}>
      {allowDocumentMessage && (
        <div className={styles.fields}>
          <div className={styles.fieldRow}>
            <div
              className={classNames({
                [styles.errorFieldContainer]:
                  documentMessageMeta.touched && documentMessageMeta.error,
              })}
            >
              <label htmlFor="document.message">
                {intl.formatMessage(messages.fieldEmailLabel)}
              </label>
              <Field
                name="document.message"
              >
                {({ field }: FieldProps) => <TextArea
                  id="document.message"
                  rows={4}
                  disabled={lockDocumentMessage}
                  data-qa-ref="document.fields.message"
                  {...field} />}
              </Field>
              <div
                className={styles.errorContainer}
                role="message-error"
                data-qa-ref="document.errors.message"
              >
                <ErrorMessage
                  name="document.message"
                  className={styles.error} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default DocumentSection;
